/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thin_Lean_Bull_PurrInputs */

const en_thin_lean_bull_purr = /** @type {(inputs: Thin_Lean_Bull_PurrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Users`)
};

const de_thin_lean_bull_purr = /** @type {(inputs: Thin_Lean_Bull_PurrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer exportieren`)
};

/**
* | output |
* | --- |
* | "Export Users" |
*
* @param {Thin_Lean_Bull_PurrInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const thin_lean_bull_purr = /** @type {((inputs?: Thin_Lean_Bull_PurrInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thin_Lean_Bull_PurrInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thin_lean_bull_purr(inputs)
	return de_thin_lean_bull_purr(inputs)
});